<nz-list [class.mobile]="isMobile()" nzSize="small" class="addInfo-list">
  @for (addInfo of addInfoValues(); track $index) {
    @if (addInfo.fieldType === "single") {
      <nz-list-item class="regular addInfo-list-item">
        <span class="body-bold-cap addInfo-label">
          {{ addInfo.labelkey(i18n) }}
        </span>

        @if (addInfo.icon) {
          <i nz-icon [nzType]="'icons:done-full-circle'"></i>
        }
        @if (isSteamCurrency(addInfo)) {
          <span>
            {{ addInfo.value }} {{ steamLossCurrencyUnit() + "/ton" }}
          </span>
        } @else {
          @if (addInfo.valueType) {
            <span>
              {{
                addInfo.value
                  | unit: addInfo : i18n.pipeCompatibleMeasurementSystem()
              }}
            </span>
          } @else {
            <span>{{ addInfo.text }}</span>
          }
        }
      </nz-list-item>
    }
    @if (addInfo.fieldType === "dropdown") {
      <nz-list-item class="regular addInfo-list-item">
        <span class="body-bold-cap addInfo-label">
          {{ addInfo.labelkey(i18n) }}
        </span>

        @if (addInfo.icon) {
          <i nz-icon [nzType]="'icons:done-full-circle'"></i>
        }
        @if (addInfo.valueType) {
          <span>
            {{
              addInfo.value
                | unit: addInfo : i18n.pipeCompatibleMeasurementSystem()
            }}
          </span>
        } @else {
          <span>{{ i18n.parse(addInfo.text) }}</span>
        }
      </nz-list-item>
    }
    @if (
      addInfo.fieldType === "multiple" &&
      (addInfo.multipleValues?.length ?? 0) > 0 &&
      addInfo.multipleValues![0] !== ""
    ) {
      <nz-list-item class="regular addInfo-list-item">
        <span class="body-bold-cap addInfo-label">
          {{ addInfo.labelkey(i18n) }}
        </span>

        @for (value of addInfo.multipleValues!; track $index) {
          <div>
            @if (addInfo.icon) {
              <i nz-icon [nzType]="'icons:done-full-circle'"></i>
            }
            <span>{{ value }}</span>
          </div>
        }
      </nz-list-item>
    }
    @if (addInfo.fieldType === "radio") {
      <nz-list-item class="regular addInfo-list-item">
        <span class="body-bold-cap addInfo-label">
          {{ addInfo.labelkey(i18n) }}
        </span>

        @if (addInfo.icon) {
          <i nz-icon [nzType]="'icons:done-full-circle'"></i>
        }
        @if (!addInfo.valueType) {
          <span>{{ addInfo.text }}</span>
        }
      </nz-list-item>
    }
  }

  <div class="addInfo-button-wrapper">
    @if (
      !showLoadingSpinner() &&
      addInfoValues().length > 0 &&
      addInfoValues()![0].infoTypeID !== 4
    ) {
      <app-nav-button
        [darksecondary]="true"
        [svgIcon]="'icons:edit'"
        class="desktopMaxWidthBtn"
        (clickEvent)="onClickEdit()"
      >
        {{ i18n.langString("edit_information") }}
      </app-nav-button>
    }
    @if (showLoadingSpinner()) {
      <app-spinner [black]="true"></app-spinner>
    }
  </div>
</nz-list>
